import React from 'react';
import * as S from '../../../../PodHomePage/components/Screen/components/OnDemandModal/style';
import { AdsureTabType } from 'containers/PodHomePage/components/Screen/components/OnDemandModal/types';

interface TabsProps {
  activeTab: AdsureTabType;
  onTabChange: (tab: AdsureTabType) => void;
}

export const Tabs: React.FC<TabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <S.Tabs>
      <S.Tab
        active={activeTab === 'manual'}
        onClick={() => onTabChange('manual')}
      >
        Manual Upload
      </S.Tab>
      <S.Tab
        active={activeTab === 'mosaic'}
        onClick={() => onTabChange('mosaic')}
      >
        Pull creatives from Mosaic
      </S.Tab>
      <S.Tab
        active={activeTab === 'webTester'}
        onClick={() => onTabChange('webTester')}
      >
        Web URL Tester
        <span
          style={{
            marginLeft: 6,
            backgroundColor: '#8A2BE2',
            color: 'white',
            fontSize: 10,
            padding: '1px 6px',
            borderRadius: 4,
            fontWeight: 600,
          }}
        >
          BETA
        </span>
      </S.Tab>
    </S.Tabs>
  );
};
